const envConfig = 'ebankingweblux';

const rmRegion ="rmch"

module.exports = { envConfig, rmRegion };
